import { FlexBox, SPACING, Typography } from "@joonapp/web-shared"
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"

import "./styles.scss"
import PromptTextArea from "./PromptTextArea"
import AnimatedStars from "../../../components/animatedStars/AnimatedStars"
import TransitionWrapper from "../../../components/coaching/TransitionWrapper"

const QuestAIWelcome = () => {
  const [visibleSections, setVisibleSections] = useState<number[]>([])
  const [isStarAnimating, setIsStarAnimating] = useState(true)
  const { t } = useTranslation()

  useEffect(() => {
    const sectionDelays = [0, 2000, 3500, 5000, 6500, 8000] // Individual delays for each section

    sectionDelays.forEach((delay, index) => {
      setTimeout(() => {
        setVisibleSections((prev) => [...prev, index])
      }, delay)
    })
  }, [])

  useEffect(() => {
    setIsStarAnimating(true)
    const timeout = setTimeout(() => {
      setIsStarAnimating(false)
    }, 2000)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <FlexBox
      direction="column"
      gap={SPACING.space6}
      align="center"
      style={{
        padding: `${SPACING.space6}`,
        paddingTop: `${SPACING.space12}`,
        position: "relative",
        flex: 1,
        transform: isStarAnimating ? "translateY(100px)" : "translateY(0px)",
        transition: "transform 0.5s ease-in-out",
      }}
    >
      <TransitionWrapper showChildren={visibleSections.includes(0)}>
        <AnimatedStars animate={isStarAnimating} scale={3} />
      </TransitionWrapper>
      <TransitionWrapper showChildren={visibleSections.includes(1)}>
        <div className="gradient-text">
          <Typography variant="aiExpressive" style={{ fontSize: "36px" }}>
            {t("JOONIPER_WELCOME_GREETING")}
          </Typography>
        </div>
      </TransitionWrapper>
      <TransitionWrapper showChildren={visibleSections.includes(2)}>
        <Typography
          variant="body"
          textAlign="center"
          style={{
            fontFamily: "Lora",
            fontStyle: "italic",
            padding: `0 ${SPACING.space2}`,
            fontWeight: 500,
          }}
        >
          {t("JOONIPER_WELCOME_SUB")}
        </Typography>
      </TransitionWrapper>
      <TransitionWrapper showChildren={visibleSections.includes(3)}>
        <Typography
          variant="aiBody"
          textAlign="center"
          style={{ padding: `0 ${SPACING.space2}` }}
        >
          {t("JOONIPER_WELCOME_USE")}
        </Typography>
      </TransitionWrapper>
      <TransitionWrapper showChildren={visibleSections.includes(4)}>
        <Typography
          variant="aiBody"
          textAlign="center"
          style={{ padding: `0 ${SPACING.space10}` }}
        >
          {t("JOONIPER_TELL_ME_GOAL")}
        </Typography>
      </TransitionWrapper>
      <TransitionWrapper
        showChildren={visibleSections.includes(5)}
        style={{ width: "100%", marginTop: "auto" }}
      >
        <PromptTextArea />
      </TransitionWrapper>
    </FlexBox>
  )
}

export default QuestAIWelcome
